module.exports = __webpack_public_path__ + "static/media/fac6.e10521ab.jpg";